import React, {useEffect} from 'react';
import {
  AppLayout,
  ParentCategories,
} from 'sections/services-marketplace/experts/components';
import {Helmet} from 'react-helmet';
import {producePageViewMonorailEvent} from '../../utilities/monorail';
import {MonorailPageIndicators} from '../../utilities/constants';

export default function CategoryIndex() {
  useEffect(() => {
    producePageViewMonorailEvent({
      pageIndicator: MonorailPageIndicators.categoryIndex,
    });
  }, []);

  return (
    <AppLayout>
      <Helmet>
        <link rel="canonical" href="https://experts.shopify.com/services" />
      </Helmet>
      <AppLayout.Container>
        <AppLayout.Section fill>
          <ParentCategories />
        </AppLayout.Section>
      </AppLayout.Container>
    </AppLayout>
  );
}
